import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const Location: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      className={UNSAFE_className || ''}
      {...props}
      height={IconHeight[size]}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 7.11415C13.254 7.11415 11.028 9.37522 11.028 12.1644C11.028 14.9535 13.254 17.2146 16 17.2146C18.746 17.2146 20.972 14.9535 20.972 12.1644C20.972 9.37522 18.746 7.11415 16 7.11415ZM12.9161 12.1644C12.9161 10.4344 14.2968 9.03196 16 9.03196C17.7032 9.03196 19.0839 10.4344 19.0839 12.1644C19.0839 13.8944 17.7032 15.2968 16 15.2968C14.2968 15.2968 12.9161 13.8944 12.9161 12.1644Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2C11.0294 2 7 6.09281 7 11.1416C7 13.6235 8.21188 17.3655 9.79319 20.8454C11.3832 24.3443 13.453 27.8101 15.3325 29.7191C15.6839 30.0761 16.2476 30.0952 16.6217 29.7627C18.7918 27.834 20.8734 24.3351 22.4016 20.832C23.9281 17.3328 25 13.6045 25 11.1416C25 6.09281 20.9706 2 16 2ZM8.88811 11.1416C8.88811 7.15199 12.0722 3.91781 16 3.91781C19.9278 3.91781 23.1119 7.15199 23.1119 11.1416C23.1119 13.1977 22.1698 16.6292 20.6753 20.0551C19.3593 23.0719 17.6906 25.9095 16.0409 27.6705C14.5419 25.8874 12.8708 23.0419 11.5075 20.0417C9.94197 16.5965 8.88811 13.1787 8.88811 11.1416Z"
        fill="black"
      />
    </svg>
  );
};

export default Location;
